<div class="wrapper wrapper-full-page">
  <div class="page-header login-page header-filter" filter-color="custom">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
          <div class="text-center">
            <img style="max-width: 150px;height: auto;" src="./assets/img/logo.jpeg" />
          </div>
          <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="card card-login card-hidden">
              <div class="card-body ">
                <h3 class="card-description text-center mt-4 mb-4">Connexion</h3>
                <div class="content">
                  <div class="form-group" [ngClass]="displayFieldCss(form, 'identifier')">
                    <label class="form-label">Adresse e-mail</label>
                    <input type="email" class="form-control" formControlName="identifier" placeholder="Entrez votre adresse">
                  </div>
                  <div class="form-group" [ngClass]="displayFieldCss(form, 'password')">
                    <label class="form-label">Mot de passe</label>
                    <input type="password" class="form-control" formControlName="password" placeholder="Entrez votre mot de passe">
                  </div>
                </div>
              </div>
              <div class="card-footer justify-content-center">
                <a [routerLink]="['/auth', 'forgot']" class="link">Mot de passe oublié</a>
              </div>
              <div class="card-footer justify-content-center mb-3">
                <button type="submit" [disabled]="isSubmitting" class="btn btn-primary btn-fill">Connexion</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
